import CustomSelectOption from "@components/CustomSelectOption";
import Pagination from "@components/Pagination";
import FloatScrollButton from "@components/ui/FloatScrollButton";
import NewCourses from "@components/ui/landing/NewCourses";
import { setPaginationData } from "@store/reducers/paginations";
import Surprise from "assets/svg/surprise.svg";
import { SEOHEAD, Spinner, Title } from "components";
import Items from "components/ui/search/Tab/Items";
import gate from "gate";
import { NextPageContext } from "next";
import { useRouter } from "next/router";
import React, { FC, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { getNameAndEnumForCourseType } from "src/utils";

type SEOType = {
  online: {
    keyword: string[];
    seoDescription: string;
    title: string;
  };
  ofline: {
    keyword: string[];
    seoDescription: string;
    title: string;
  };
  "in-class": {
    keyword: string[];
    seoDescription: string;
    title: string;
  };
} & {
  [key: string]: {
    keyword: string[];
    seoDescription: string;
    title: string;
  };
};

export const SEO: SEOType = {
  online: {
    keyword: ["بسته حقوقی آنلاین"],
    seoDescription:
      "بسته های حقوقی آنلاین دادبانان در بستر پلتفرم دادبانان با امکانات مناسب، ابزاری مطلوب جهت آموزش حقوق کاربردی از راه دور است",
    title: "بسته حقوقی آنلاین | مؤسسه دادبانان",
  },
  ofline: {
    keyword: ["بسته حقوقی آفلاین"],
    seoDescription:
      " بسته حقوقی آفلاین دادبانان بر اساس مهمترین نیاز وکلا و فارغ التحصیلان حقوقی، در صدد افزایش مهارت‌های کاربردی جامعه حقوقی کشور است",
    title: "بسته حقوقی آفلاین | مؤسسه دادبانان",
  },
  "in-class": {
    keyword: ["بسته حقوقی حضوری"],
    seoDescription:
      "بسته حقوقی حضوری دادبانان در قالب کارگاه های کاربردی به ارتقای عملی مهارت وکلا، کارآموزان وکالت، مشاوران حقوقی و فارغ التحصیلان حقوقی کمک می کند.",
    title: "بسته حقوقی حضوری | مؤسسه دادبانان",
  },
  free: {
    keyword: ["بسته حقوقی رایگان"],
    seoDescription:
      "دادبانان در راستای ترویج حقوق کاربردی، بسته حقوقی رایگان متعددی به صورت وبینار برگزار نموده است که همه وبینارهای حقوقی دادبانان به صورت رایگان در سایت دادبانان در دسترس مخاطبان عزیز دادبانان است.",
    title: "بسته حقوقی رایگان | مؤسسه دادبانان",
  },
};
let _timer: any | null = null;
const Index: FC = () => {
  const { query: pageQuery } = useRouter();
  const dispatch = useDispatch();
  const paginationsState = useSelector((state: any) => state.paginations);
  const isFirstMounted = useRef(true);
  const [recommendedList, setRecommendedList] = useState<null | []>(null);
  const [totalCount, setTotalCount] = useState(null);
  const [searchData, setSearchData] = useState({
    search: "",
    pageSize: 15,
    pageNumber: paginationsState.paginations[
      pageQuery && pageQuery.type?.length ? pageQuery.type[0] : "package-type"
    ]
      ? paginationsState.paginations[
          pageQuery && pageQuery.type?.length
            ? pageQuery.type[0]
            : "package-type"
        ]
      : 1,
    fieldSearchs: [
      {
        fieldName: "",
        text: "",
      },
    ],
  });
  const state = useSelector((state: any) => state.search);
  const {
    mutate,
    data: items,
    isLoading,
  }: any = useMutation(gate.searchAdvanceWithPagination);

  const {
    query,
    entityType,
    courseType,
    packageType,
    fromPrice,
    toPrice,
    courseCategoryIds,
    teacherIds,
    certificateIds,
    sortBy,
  } = state;

  useEffect(() => {
    if (pageQuery && pageQuery.type?.length) {
      if (
        paginationsState.paginations[
          pageQuery && pageQuery.type?.length
            ? pageQuery.type[0]
            : "package-type"
        ]
          ? paginationsState.paginations[
              pageQuery && pageQuery.type?.length
                ? pageQuery.type[0]
                : "package-type"
            ]
          : 1
      ) {
        const tempPagination = JSON.parse(JSON.stringify(paginationsState));
        tempPagination.paginations[
          pageQuery && pageQuery.type?.length
            ? pageQuery.type[0]
            : "package-type"
        ] = searchData.pageNumber;
        dispatch(setPaginationData(tempPagination.paginations));
      } else {
        dispatch(
          setPaginationData({
            ...paginationsState.paginations,
            [pageQuery && pageQuery.type?.length
              ? pageQuery.type[0]
              : "package-type"]: searchData.pageNumber,
          })
        );
      }

      if (pageQuery.type[0] === "free") {
        mutate(
          {
            query: "",
            entityType: [1],
            courseType: [],
            fromPrice: 0,
            courseCategoryIds,
            teacherIds,
            certificateIds,
            sortBy,
            searchDto: searchData,
            isRecommended: true,
          },
          {
            onSuccess: (data: any) => {
              if (!isFirstMounted.current) {
                const getOffsetTop =
                  document.getElementById("postsWrapper")?.offsetTop;
                window.scrollTo({
                  top:
                    getOffsetTop && getOffsetTop > 0
                      ? getOffsetTop - 30
                      : getOffsetTop,
                  behavior: "smooth",
                });
              }
              setRecommendedList(data?.data?.output?.recommended);
              setTotalCount(data?.pagination.totalCount);

              if (isFirstMounted.current) {
                isFirstMounted.current = false;
              }
            },
          }
        );
      } else {
        mutate(
          {
            query: pageQuery?.query ? pageQuery?.query : query,
            entityType: pageQuery?.entityType ? [+pageQuery?.entityType] : [1],
            courseType: [],
            packageType: pageQuery?.type
              ? getNameAndEnumForCourseType(pageQuery?.type?.[0])?.id
              : packageType,
            fromPrice: pageQuery?.type ? 1 : fromPrice,
            toPrice,
            courseCategoryIds,
            teacherIds,
            certificateIds,
            sortBy,
            searchDto: searchData,
            isRecommended: true,
          },
          {
            onSuccess: (data: any) => {
              if (!isFirstMounted.current) {
                const getOffsetTop =
                  document.getElementById("postsWrapper")?.offsetTop;
                window.scrollTo({
                  top:
                    getOffsetTop && getOffsetTop > 0
                      ? getOffsetTop - 30
                      : getOffsetTop,
                  behavior: "smooth",
                });
              }
              setRecommendedList(data?.data?.output?.recommended);
              setTotalCount(data?.pagination.totalCount);
              if (isFirstMounted.current) {
                isFirstMounted.current = false;
              }
            },
          }
        );
      }
    }
  }, [pageQuery, sortBy, searchData]);

  // useEffect(() => {
  //   if (searchData) {
  //     mutate(
  //       {
  //         query,
  //         entityType: [1],
  //         courseType,
  //         fromPrice,
  //         toPrice,
  //         courseCategoryIds,
  //         teacherIds,
  //         certificateIds,
  //         sortBy,
  //         searchDto: searchData,
  //       },
  //       {
  //         onSuccess: (data: any) => {
  //           const getOffsetTop =
  //             document.getElementById("postsWrapper")?.offsetTop;
  //           window.scrollTo({
  //             top:
  //               getOffsetTop && getOffsetTop > 0
  //                 ? getOffsetTop - 30
  //                 : getOffsetTop,
  //             behavior: "smooth",
  //           });
  //           // setRecommendedList(data?.data?.output?.recommended);
  //           setTotalCount(data?.pagination.totalCount);
  //         },
  //       }
  //     );
  //   }
  // }, [searchData]);

  const onShowChange = (data: { key: string; value: string }) => {
    setSearchData({
      ...searchData,
      pageSize: +data.key,
      pageNumber: 1,
    });
  };

  const pageNumbersHandler = (pageNumber: number, pageSize: number) => {
    if (totalCount) {
      const totalPages =
        totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
      // last page
      if (pageNumber === totalPages) {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {totalCount}
          </>
        );
        // first page
      } else if (pageNumber === 1) {
        return (
          <>
            {pageNumber} - {pageSize}
          </>
        );
        // middle pages
      } else {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {pageNumber * pageSize}
          </>
        );
      }
    }
    return null;
  };
  const scrollToPostsWrapper = () => {
    if (_timer) {
      clearTimeout(_timer);
    }
    _timer = setTimeout(() => {
      const getOffsetTop = document.getElementById("postsWrapper")?.offsetTop;
      window.scrollTo({
        top:
          getOffsetTop && getOffsetTop > 0 ? getOffsetTop - 30 : getOffsetTop,
        behavior: "smooth",
      });
    }, 0);
  };
  const onPageChange = (page: number) => {
    scrollToPostsWrapper();
    setSearchData({
      ...searchData,
      pageNumber: page,
    });
  };
  const seoData =
    SEO[getNameAndEnumForCourseType(pageQuery?.type?.[0])?.name as string];
  return (
    <>
      <SEOHEAD
        {...{
          canonical: `https://dadbanan.com/package-type/${
            getNameAndEnumForCourseType(pageQuery?.type?.[0])?.name
          }/${seoData?.keyword?.[0]?.replace(/\s/g, "-")}`,
          title: seoData?.title,
          keyword: seoData?.keyword,
          seoDescription: seoData?.seoDescription,
        }}
      />
      <div className="py-4 md:py-8 xl:pt-10 xl:pb-20">
        <div className="mx-auto w-[81%] md:w-[84%] xl:w-[73.9%]">
          <>
            <div className="mb-10 hidden w-full justify-between md:flex">
              <Title
                title={`${totalCount ? totalCount : 0} مورد`}
                wrapperClass="md:!text-xs font-normal lg:!text-lg"
              />
            </div>
            <div className="my-6 flex md:!hidden">
              <Title
                title={`${totalCount ? totalCount : 0} مورد`}
                wrapperClass="!font-normal -z-10 !text-xs"
              />
            </div>
            {isLoading && (
              <Spinner className="mx-auto h-10 w-10 animate-opacity animate-fade-in-down" />
            )}
            {items?.data?.output?.table?.rows.length == 0 ? (
              <div className="flex h-[60vh] items-start gap-x-5 text-xs md:text-base">
                <Surprise />
                <p>موردی یافت نشد.</p>
              </div>
            ) : (
              items?.data?.output?.table?.rows?.map((item: any) => (
                <Items key={JSON.stringify(item?.id)} item={item} />
              ))
            )}
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2">
              <div>
                {totalCount && totalCount > searchData.pageSize ? (
                  <Pagination
                    totalCount={totalCount}
                    pageSize={searchData.pageSize}
                    onPageChange={onPageChange}
                    selectedPage={
                      paginationsState.paginations[
                        pageQuery && pageQuery.type?.length
                          ? pageQuery.type[0]
                          : "package-type"
                      ]
                        ? paginationsState.paginations[
                            pageQuery && pageQuery.type?.length
                              ? pageQuery.type[0]
                              : "package-type"
                          ]
                        : 1
                    }
                  />
                ) : undefined}
              </div>
              <div>
                {(totalCount && totalCount > searchData.pageSize) ||
                searchData.pageSize !== 15 ? (
                  <div className="mt-4 flex items-center justify-center md:mt-0 md:justify-end">
                    <span className="ml-5">
                      نمایش{" "}
                      {pageNumbersHandler(
                        searchData.pageNumber,
                        searchData.pageSize
                      )}{" "}
                      از {totalCount}
                    </span>
                    <CustomSelectOption
                      list={[
                        { key: "15", value: "نمایش 15" },
                        { key: "20", value: "نمایش 20" },
                        { key: "30", value: "نمایش 30" },
                        { key: "50", value: "نمایش 50" },
                      ]}
                      isRtl={false}
                      onChange={onShowChange}
                    />
                  </div>
                ) : undefined}
              </div>
            </div>
            {recommendedList ? (
              <div className="mt-[71px]">
                {recommendedList.length == 0 ? (
                  <div className="flex h-[60vh] items-start gap-x-5 text-xs md:text-base">
                    <Surprise />
                    <p>موردی یافت نشد.</p>
                  </div>
                ) : (
                  <NewCourses
                    title="دوره ها و بسته های پیشنهادی"
                    data={recommendedList}
                    breakpoints={{
                      300: {
                        slidesPerView: 1,
                        spaceBetween: 5,
                      },
                      375: {
                        slidesPerView: 1.1,
                        spaceBetween: 5,
                      },
                      767: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      1024: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                      },
                    }}
                  />
                )}
              </div>
            ) : undefined}
          </>
        </div>
      </div>
      <FloatScrollButton />
    </>
  );
};

export async function getServerSideProps(ctx: NextPageContext): Promise<{
  props: {
    urlQuery: any;
  };
}> {
  return {
    props: { urlQuery: ctx?.query },
  };
}

export default Index;
